import Model from 'flarum/common/Model';
export default class Week extends Model {
  name = Model.attribute('name');
  seasonId = Model.attribute('seasonId');
  weekNumber = Model.attribute('weekNumber');
  season = Model.hasOne('season');
}
flarum.reg.add('huseyinfiliz-pickem', 'common/models/Week', Week);